//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  computed: {
    isLeftSidebarOpen: {
      get() {
        //if we have other stakes
        return this.$store.state.leftSidebarOpen
      },
      set(value) {
        this.$store.commit('openLeftSidebar', true)
      }
    },
    tab() {
      let tab = 'sports'
      if (_.includes(this.$route.name, 'live')) {
        tab = 'live'
      }
      if (_.includes(this.$route.name, 'virtual')) {
        tab = 'virtual'
      }
      if (_.get(this.$store.state, 'tab')) {
        tab = _.get(this.$store.state, 'tab')
      }
      return tab
    },
    balance() {
      if (_.has(this.user, 'balance')) {
        return this.format_money(_.get(this.user, 'balance'), _.get(this.user, 'currency'))
      }
      return null
    }
  },
  methods: {
    async openCashier() {
      this.loadGlobalIframe('open_page', { url: '/cashier/deposit' })
    },

    async goTo(url) {
      if (_.startsWith(url, 'http')) return url
      return this.localePath(url)
    },
    async openSignup() {
      this.$router.push(this.localePath({ path: '/auth/register' }))
    },
    async goHome() {
      this.loadGlobalIframe('hide_iframe', {}, true)
      if (this.$device.isMobile) {
        window.scroll({ top: 0, behavior: 'smooth' })
      } else {
        document.getElementById('main_body').scroll({ top: 0, behavior: 'smooth' })
      }
    },
    async closeIframe() {
      this.loadGlobalIframe('hide_iframe', {}, true)
    },
    async openLeftSidebar() {
      this.$store.commit('openLeftSidebar', true)
      this.$store.commit('betslip/toggleBetslip', false)
    },
    async toggleLeftSidebar() {
      
      this.$store.commit('openLeftSidebar', !this.isLeftSidebarOpen)
      this.$store.commit('betslip/toggleBetslip', false)
    },
    async openRightSidebar() {
      this.loadGlobalIframe('hide_iframe', {}, true)
      this.$store.commit('openRightSidebar', true)
      this.$store.commit('betslip/toggleBetslip', false)
    }
  }
}
